<template>
  <div class="table">
    <!--=========查询模块================-->
    <div class="container">
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="100px">
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="用户名" prop="name">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.name"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="用户账号" prop="emplid">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.emplid"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="16">
            <el-col :span="8">
              <el-form-item label="联系邮箱" prop="email">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.email"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话" prop="phone">
                <el-input class="handle-input" clearable v-model.trim="queryCondition.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex" justify="center">
            <el-button type="primary" @click="search">{{$t('common.search')}}</el-button>
            <el-button type="primary" @click="restQueryForm">{{$t('common.reset')}}</el-button>

          </el-row>
        </el-form>
      </div>
      <div class="toolsBox">
        <el-button type="primary" @click="pickUp">{{$t('common.confirm')}}</el-button>
        <el-button type="primary" @click="toggleSelection">{{$t('common.Deselected')}}</el-button>
      </div>
      <el-table :data="tableData" ref="pickUserTable" row-key="tmUserId" border style="margin-top:20px" max-height='350' @selection-change="selectionChange" highlight-current-row>
        <el-table-column prop="tmUserId" type="selection" width="55" align="center" />
        <el-table-column prop="name" label="用户名"></el-table-column>
        <el-table-column prop="emplid" label="用户账号"></el-table-column>
        <el-table-column prop="email" label="联系邮箱"></el-table-column>
        <el-table-column prop="phone" label="联系电话"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { userService } from "@/api/user-manage/user";
import { Message } from "element-ui";
import commonFun from "@/utils/commonFun";

export default {
  name: "pickupUser",
  props: {
    value: String,
    title: String,
    placeholder: String,
    selectDatas: Array, //useless by now
    supplierIds: Array,
  },
  data() {
    return {
      puPlaceholder: this.placeholder,
      tableData: [],
      radioVal: null,
      selectedId: this.value,
      selectDataAll: {
        defaultData: commonFun.convertToArray(this.value),
        pageDatas: []
      },
      totalCount: 0,
      labelPosition: "right",
      queryCondition: {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: '',
        emplFlag: "MCD"
      },
      showDialog: false,
      notSelRoles: [],
      selRoles: [],
      userId: null,
      userInfo: {},
      showUserInfo: false,
      selectRows: [],
    };
  },
  created() {
    this.queryData();
  },
  computed: {
    getSelectedData() {
    },
    transferTo() {
      return this.value;
    }
  },
  watch: {
    value(newVal) {
      console.log(newVal);
    },
    supplierIds(newVal) {
      console.log('newVal', newVal);
      if (newVal) {
        this.$nextTick(() => {
          this.selectedDefaultFun()
        });
      }
    }
  },
  methods: {
    // 取消选择
    toggleSelection() {
      this.$refs.pickUserTable.clearSelection();
      for (let k in this.selectedTouched) {
        this.selectedTouched[k] = true;
      }
    },
    queryData() {
      userService.getUsersupplierList(this.queryCondition).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      }).then(value => {
        this.$nextTick(() => {
          this.selectedDefaultFun()
        });
      });
    },
    //默认选中
    selectedDefaultFun() {
      let userIds = this.supplierIds;
      console.log('userIds', userIds);
      if (userIds.length > 0) {
        var arr = this.tableData.filter(ele => {
          return userIds.includes(ele.tmUserId)
        }).forEach(row => {
          this.$refs.pickUserTable.toggleRowSelection(row);
        })
      }
    },
    search() {
      this.queryCondition.pageNum = 1
      this.queryData();
    },
    // 确认
    pickUp() {
      sessionStorage.setItem('selectSupplier', JSON.stringify(this.selectRows))
      this.$emit('closeSelSupplier')
    },
    // 多选
    selectionChange(rows) {
      this.selectRows = rows
    },
    //页码变化
    pageNumberChange(val) {
      this.queryCondition.pageNum = val;
      this.queryData();
    },
    //显示条数变更
    pageSizeChange(val) {
      this.queryCondition.pageSize = val;
      this.queryData();
    },
    //查询条件重置方法
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.$refs.pickUserTable.clearSelection();
      this.queryCondition = {
        pageSize: 15,
        pageNum: 1,
        name: "",
        emplid: "",
        email: '',
        phone: ''
      }
      this.queryData();
    },
  }
};
</script>
<style scoped>
.handle-input {
  width: 95%;
}

.form_border {
  border: 1px solid #eaeefb;
  padding: 10px 10px 0;
}

/*穿梭框样式重写*/
.el-transfer .el-transfer-panel {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  overflow: hidden;
  background: #fff;
  display: inline-block;
  vertical-align: middle;
  width: 255px;
  max-height: 100%;
  box-sizing: border-box;
  position: relative;
}

.el-transfer-panel__body {
  height: 370px;
}

.el-transfer-panel__list.is-filterable {
  height: 360px;
}
</style>
